<template>
  <div class="OnlineBook">
    <div v-if="!wxtoken">
      <mu-container class="WxBtn">
        <mu-button fab color="#01B307" @click="WxLogin">
          <img height="20" src="../../../static/img/wechart.png">
        </mu-button>
        <div class="WxText">使用微信登陆</div>
      </mu-container>
    </div>
    <div v-else>
      <div v-if="IsApp">
        <div v-if="OnMod.BookState === 1">
          <wait/>
        </div>
        <div v-if="OnMod.BookState === 2">
          <verify-ref :on-mod="OnMod" @ReApp="ReApp"/>
        </div>
        <div v-if="OnMod.BookState === 3">
          <view-page :id="Id" :open-code="OpenCode"/>
        </div>
      </div>
      <div v-else>
        <online-book-page :mod-id="Id" @ApplySuccess="ApplySuccess"/>
      </div>
    </div>
  </div>
</template>

<script>
import Toast from 'muse-ui-toast'
import { OnlineBookPage, Wait, VerifyRef, ViewPage } from './components/index'
import { mapGetters } from 'vuex'
import { getQueryString } from '../../utils/common'
import { GetUserCanOpen } from '../../api/all'
export default {
  name: 'OnlineBook',
  components: { OnlineBookPage, Wait, VerifyRef, ViewPage },
  data() {
    return {
      IsApp: false,
      IsCanOpen: false,
      OnMod: {},
      OpenCode: '',
      Id: 0
    }
  },
  computed: {
    ...mapGetters([
      'wxtoken'
    ]),
    getIsUserLogin() {
      return this.UserLogin
    }
  },
  created() {
    // location.replace('http://192.168.1.106:3232')
    // this.IsWxLogin()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.IsWxLogin()
    })
  },

  methods: {
    // 查看是否登录
    IsWxLogin: function() {
      if (!this.$store.getters.wxtoken) {
        Toast.info('请先登录')
      } else {
        this.GetUserIsCanOpen()
      }
    },
    WxLogin: function() {
      var AppId = 'wx62efb5485152c882'
      // var AppId = 'wxb497fec48eea1e29'
      var RedUrl = encodeURI(window.location.href).split('#')[0]
      // https://ztyy.zmj.com/
      var Code = getQueryString('code')
      if (Code) {
        RedUrl = RedUrl.split('?')[0]
      }
      this.$store.dispatch('setBeforeRou', 'online')
      var url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + AppId + '&redirect_uri=' + RedUrl + '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
      window.location.href = url
    },
    GetUserIsCanOpen: function() {
      this.OpenCode = ''
      this.OnMod = {}
      GetUserCanOpen(this.$store.getters.wxuserid).then(res => {
        console.log(res)
        this.IsApp = res.data.IsApp
        this.IsCanOpen = res.data.IsCanOpen
        this.OnMod = Object.assign(res.data.OnMod)
        if (this.IsCanOpen) {
          this.OpenCode = this.OnMod.OpenCode
          this.Id = this.OnMod.Id
          // var url = 'https://ztyy.zmj.com/vtour/tour.html?opencode=' + this.OnMod.OpenCode + '&id=' + this.OnMod.Id
          // window.location.href = url
        }
      })
    },
    ApplySuccess: function() {
      this.GetUserIsCanOpen()
    },
    ReApp: function() {
      this.IsApp = false
    }
  }
}
</script>

<style scoped>
.WxBtn{
  text-align: center;
  margin-top: 80px;
}

.WxText{
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/view/OnLineBook/index.vue